import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { PropTypes } from 'prop-types';

const Snack = ({ open, message, setOpen }) => {
  const [openSnack, setOpenSnack] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      setOpenSnack(true);
    }
  }, [open]);

  React.useEffect(() => {
    if (!openSnack) {
      setOpen(false);
    }
  }, [open]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={openSnack}
      autoHideDuration={6000}
      onClose={handleClose}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      message={<span id="message-id">{message}</span>}
    />
  );
};

Snack.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default Snack;
